document.addEventListener("DOMContentLoaded", () => {
  const video = document.getElementById("heroVideo");

  function startRandomVideo() {
    if (!video || !video.duration) return;

    const safeDuration = Math.max(video.duration - 5, 0);
    video.currentTime = Math.random() * safeDuration;

    video.muted = true;
    video.playsInline = true;

    video.play().catch(() => {
      video.setAttribute("autoplay", "autoplay");
    });
  }

  if (video.readyState >= 1) {
    startRandomVideo();
  } else {
    video.addEventListener("loadedmetadata", startRandomVideo, { once: true });
  }
});